(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const TEMPLATE_SELECTOR = 'main[data-template^="product"]';

  function initializeMobileProductHeader() {
    const main = document.querySelector(TEMPLATE_SELECTOR);
    if (!main) return;

    const grid = main.querySelector(
      '.product-information__grid[data-product-grid-content]'
    );
    const media = grid?.querySelector(
      ':scope > .product-information__media[data-testid="product-information-media"]'
    );
    const details = grid?.querySelector(
      ':scope > [data-testid="product-information-details"]'
    );
    const variantPicker = details?.querySelector('variant-picker');
    const title = details?.querySelector('h1');
    const header = title?.closest('[data-testid="group-block"]');

    if (
      !grid ||
      !media ||
      !details ||
      !variantPicker ||
      !header ||
      header.contains(variantPicker) ||
      header.dataset.ohsioMobileHeader === 'true'
    ) {
      return;
    }

    const originalParent = header.parentNode;
    const originalNextSibling = header.nextSibling;
    const mediaQuery = window.matchMedia(MOBILE_QUERY);

    header.dataset.ohsioMobileHeader = 'true';
    header.classList.add('ohsio-mobile-product-header');

    const updatePosition = () => {
      if (mediaQuery.matches) {
        header.style.setProperty('grid-column', '1 / -1');
        header.style.setProperty('width', '100%');
        header.style.setProperty('max-width', '100%');
        header.style.setProperty('min-width', '0');
        header.style.setProperty('writing-mode', 'horizontal-tb');

        header.querySelectorAll('h1, h2, h3, p, span, product-price').forEach(
          (element) => {
            element.style.setProperty('writing-mode', 'horizontal-tb');
            element.style.setProperty('word-break', 'normal');
            element.style.setProperty('overflow-wrap', 'break-word');
          }
        );

        grid.insertBefore(header, media);
      } else if (originalParent && header.parentNode !== originalParent) {
        header.style.removeProperty('grid-column');
        header.style.removeProperty('width');
        header.style.removeProperty('max-width');
        header.style.removeProperty('min-width');
        header.style.removeProperty('writing-mode');

        header.querySelectorAll('h1, h2, h3, p, span, product-price').forEach(
          (element) => {
            element.style.removeProperty('writing-mode');
            element.style.removeProperty('word-break');
            element.style.removeProperty('overflow-wrap');
          }
        );

        originalParent.insertBefore(header, originalNextSibling);
      }
    };

    updatePosition();
    mediaQuery.addEventListener('change', updatePosition);

    document.addEventListener('shopify:section:load', updatePosition);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMobileProductHeader);
  } else {
    initializeMobileProductHeader();
  }

  [300, 1200, 3000].forEach((delay) =>
    window.setTimeout(initializeMobileProductHeader, delay)
  );
  window.addEventListener('pageshow', initializeMobileProductHeader);
  document.addEventListener('shopify:section:load', initializeMobileProductHeader);
})();
